import { MenuDocument, MenuItem } from "features/editor/MenuDocumentModel";


export interface LabelDocument extends MenuDocument {
    type: 'label';
    template: LabelTemplate;
}

export function isLabelDocument(value: MenuDocument): value is LabelDocument {
    return value.type === 'label';
}


export interface LabelItem extends MenuItem {
    type: 'label'
    templateData: TemplateData;
    variation: Variation;
}

export function isLabelItem(item: MenuItem): item is LabelItem {
    return item.type === 'label';
}

export type CSSStyle = React.CSSProperties;

export interface Size {
    width: number;
    height: number;
}

export interface Position {
    x: number;
    y: number;
    origin?: "center"
    originX?: "center"
    originY?: "center"
}

export interface LabelTemplate {
    id: string;
    size: Size;
    imageUrl: string;
    templateData: TemplateData;
    variations: Variation[];
}

export interface TemplateData {
    document: TemplateDocument;
    defaultStyle: CSSStyle;
}

export type TemplateDocument = TemplateNode[];

export type TemplateNodeId = string;

export interface TemplateNode {
    type: string;
    id: TemplateNodeId;
    style?: CSSStyle;
    position?: Position;
    hidden?: boolean;
}

export interface ContainerNode extends TemplateNode {
    type: "container";
    background: {
        url?: string;
        color?: string;
    }
    children: TemplateNode[];
}

export function isContainerNode (node: TemplateNode): node is ContainerNode {
    return node.type === "container";
}

export interface TextNode extends TemplateNode {
    type: "text";
    content: string;
}

export interface LogoNode extends TemplateNode {
    type: "logo";
    withBackground?: boolean;
    logoBackgroundUrl?: string;
    logoUrl?: string;
}

export type VariatedNode = Omit<TemplateNode, 'type'>;

export interface Variation {
    name: string;
    nodes: VariatedNode[];
}
